const CURRENCY_CHAR = "₽";

export function currency(input) {
  const formatted = new Intl.NumberFormat("ru-RU").format(+input);

  if (typeof formatted !== "string" && isNaN(formatted)) {
    return "";
  } else {
    return `${formatted} ${CURRENCY_CHAR}`;
  }
}

export function phone(input) {
  if (typeof input === "number") input = input.toString();

  const CODE = input[0];
  const OPERATOR = input.substring(1, 4);
  const FIRST_3 = input.substring(4, 7);
  const NEXT_2 = input.substring(7, 9);
  const LAST_2 = input.substring(9, 11);

  return `+${CODE} (${OPERATOR}) ${FIRST_3}-${NEXT_2}-${LAST_2}`;
}

export default { currency, phone };
